import React from 'react';
import {gql} from 'apollo-boost';
import {get, uniqBy} from 'lodash';

import client from '../../../../src/graphql/client';
import refactorFinanceRates from '../../../../src/data-restructure/data/repayment-calc-rates';
import financeRatesQuery from '../../../../src/graphql/queries/finance-rates';
import ForSaleContainer from '../../../../src/containers/ForSale';
import contentBuilderQuery from '../../../../src/graphql/queries/content-builder';
import refactorContentBuilderData from '../../../../src/data-restructure/contentBuilder';
import toTitleCase from '../../../../src/util/toTitleCase';
import getStateName from '../../../../src/util/getStateName'; 
import stockPageCalcQuery from '../../../../src/graphql/queries/pages/stock-page-calc';
import stockCalcRestructure from '../../../../src/data-restructure/pages/stock-calc';


// queries
import seoQuery from '../../../../src/graphql/queries/seo';

const ForSale = (props) => {
  return (
    <ForSaleContainer 
      {...props}
    />
  )
}

export default ForSale;

export async function getStaticPaths() {


  if (process.env.DEALER_SITE) {
    return { paths: [], fallback: false }
  }

  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      stockPages(first: 10000) {
        nodes {
          acf_stock_page {
            range
            region
            state
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const ranges = get(result, 'data.stockPages.nodes', []);
  let paths = [];
  
  const filteredRanges = ranges.filter((item) => {
    // filter out if doesn't have uri
    return (item.acf_stock_page.state && item.acf_stock_page.range && (item.acf_stock_page.region === null))
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredRanges.forEach(range => {
    const assignedDomains = ['jayco.com.au'] // Aus only
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        range: `${range.acf_stock_page.range.replace(' ', '-')}`,
        state: `${range.acf_stock_page.state}`
      }
    });
  })

  return { paths , fallback: false }
}


export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  
  const {
    params
  } = context

  const GET_DYNAMIC_RANGE_PROPS = gql`
    query GET_RANGE_DATA($uri: String) {
      stockPages(first: 10000) {
        nodes {
          id
          title
          seo {
            ${seoQuery}
          }
          acf_domains {
            assignedDomains
          }
          acf_stock_page {
            range
            offRoad
            state
            region
            postcodes
          }
          ${contentBuilderQuery('StockPage_AcfContentBuilder')}
        }
      }
      ${financeRatesQuery}
      ${stockPageCalcQuery('au')}
    }
  `
  const pageData = await client.query({
    query: GET_DYNAMIC_RANGE_PROPS,
    // variables: {
    //   uri: params.range
    // }
  });

  const calculatorModal = stockCalcRestructure(get(pageData, 'data', []));

  const pageProps = get(pageData, 'data.stockPages.nodes', []).find(item => {
    return get(item, 'acf_stock_page.range', '').replace(' ', '-').toLowerCase() === params.range.replace(' ', '-').toLowerCase() && get(item, 'acf_stock_page.state', null) && get(item, 'acf_stock_page.state', '').replace(' ', '-').toLowerCase() === params.state.replace(' ', '-').toLowerCase() && get(item, 'acf_stock_page.range', null)
  });

  const locations = get(pageData, 'data.stockPages.nodes', []).map(location => {
    return {
      region: get(location, 'acf_stock_page.region', null),
      state: get(location, 'acf_stock_page.state', null),
      postcodes: get(location, 'acf_stock_page.postcodes', null) ? get(location, 'acf_stock_page.postcodes', '').replace(/ /g,'').split(',') : []
    }
  })
  // .filter(location => {
  //   return location.region !== null
  // })

  const categories = uniqBy(get(pageData, 'data.stockPages.nodes', []).map(cat => {
    return get(cat, 'acf_stock_page.range', null)
  }))

  // seo
  // JAY26591: Update to show state data rather than state capital city data
  // const title = get(pageProps, 'title', null);
  const title = toTitleCase(params.range.replace('-', ' ')) + ' for Sale in ' + params.state.toUpperCase();
  const seo = get(pageProps, 'seo', null);
  // Update seo
  if (seo && seo.canonical) {
    seo.title = title;
    seo.canonical = seo.canonical.substring(0, seo.canonical.lastIndexOf('/'));;
    seo.opengraphTitle = title;
  }

  const assignedDomains = ['jayco.com.au'] // get(pageProps, 'data.acf_domains.assignedDomains', []); 

  const meta = {
    title,
    seo,
    assignedDomains
  };

  const rates = refactorFinanceRates(pageData, countryCode);
  
  const cbData = pageProps ? await refactorContentBuilderData(pageProps, null, 'StockPage') : null;
  const breadcrumbs = {
    list: [
      {
        link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: 'Search',
            href: '/for-sale',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: `${toTitleCase(params.range.replace('-', ' '))} for Sale`,
            href: `/for-sale/${params.range}`,
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
          title: `${getStateName(params.state)}`,
          href: `/for-sale/${params.range}/${params.state}`,
          target: '_self',
          assignedDomains
        },
        active: true
      }
    ]
  };

  return {
    props: {
      meta,
      title: `[range] for sale in ${params.state}`,
      range: params.range.replace('-', ' '), 
      state: params.state.toUpperCase(),
      rates,
      // postcodes: get(pageProps, 'acf_stock_page.postcodes', null) ? get(pageProps, 'acf_stock_page.postcodes', '').replace(/ /g,'').split(',') : [],
      // locations, // Too large - use json file instead
      categories,
      contentBuilder: cbData,
      breadcrumbs,
      footerDisclaimer: rates.disclaimer,
      calculatorModal
      // pageData,
      // pageProps: pageProps ? pageProps : null,
      // pageProps
    }
  }
}
